import React, { useEffect } from 'react';
import { useClient } from '@splitsoftware/splitio-react';

const ClientSplitDestroy = ({children, splitUserKey}) => {
  const client = useClient(splitUserKey);

  useEffect(() => () => {
    if (client) {
      client.destroy();
    }
  }, [client]);

  return React.Children.only(children);
};

export default ClientSplitDestroy;



// WEBPACK FOOTER //
// ./spa/Components/SplitIo/ClientSplitDestroy.jsx